// app/materia/materie.js

(function () {
    'use strict';
    var controllerId = 'materia';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '_', '$filter', '$translate', materia]);

    function materia($rootScope, common, bDialog, $routeParams, $uibModal, datacontext, sectionMenu, _, $filter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Materie';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura        
        vm.super = $rootScope.isAuthorized('SUPER');
        vm.list = {};
        vm.list.ordine = ['Titolo'];        
        if (!vm.super)
            vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        vm.objName = "materia"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = !$rootScope.licenzaValida;
        vm.exportDisabled = false;
        vm.addTitle = $translate.instant('NuovaMateria');
        
        vm.get = getRecord;
        //Filtro
        vm.filter = {};        
        vm.filter.titolo = ' ';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
                
        vm.add = openModal;
        //vm.update = updateItem;
        vm.update = updateItem;
        vm.delete = deleteItem;
        vm.close = close;
        vm.open = openModal;
        vm.predefinita = predefinita;

        vm.materieAssi = [];
        vm.getMaterieAssi = getMaterieAssi;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId).then(function () {
                if ($routeParams.MateriaId != null) {
                    setView('detail');

                    getRecord($routeParams.MateriaId, 0);
                }
            });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;            
            vm.filter.titolo = vm.fTitolo == null ? '' : vm.fTitolo;            

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.materia_countAll(vm.filter.titolo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            if($rootScope.isAuthorized("DOCENTE")) {
                return datacontext.materia_getAllByDocente(vm.pageSize, vm.page, vm.filter.titolo).then(function (data) {                    
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            }
            else
                return datacontext.materia_getAll(vm.pageSize, vm.page, vm.filter.titolo, 'materia').then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.materia_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                getMaterieAssi();
                

                setView('detail');
            });
        }

        function getMaterieAssi() {
            return datacontext.asse_getAllByMateriaId(vm.record.Id).then(function (data) {
                return vm.materieAssi = data;
            });
        }
        
                
        function updateItem() {
            return datacontext.materia_update(vm.record).then(function (data) {
                if (!data)
                    logSuccess($translate.instant('DatoSalvato'));
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
            //return datacontext.materia_codeExists(vm.record.Id, vm.record.Anno, vm.record.Codice).then(function (data) {
            //    if (data == true) {
            //        logError($translate.instant('CodiceMateriaEsistente'));
            //        return false;
            //    }
            //    else return datacontext.materia_update(vm.record).then(function (data) {
            //        if (!data)
            //            logSuccess($translate.instant('DatoSalvato'));
            //        else
            //            logError($translate.instant('ImpossibileSalvareDati'));
            //    });
            //});
        }

        function deleteItem(item) {
            if ($rootScope.isAuthorized("DOCENTE")) {
                var msg = ' ' + $translate.instant('Materia') + ' ' + item.Materia;
                bDialog.deleteDialog(msg).then(function () {
                    return datacontext.materia_docenteDelete(item.MateriaId).then(function (data) {
                        if (data != "204") return logError($translate.instant('ErroreRimozione'));

                        var index = vm.records.indexOf(item);
                        vm.records.splice(index, 1);
                        vm.countRecords--;
                    });
                });
            }
            else {
                var msg = ' ' + $translate.instant('materia') + ' ' + item.Titolo;
                bDialog.deleteDialog(msg).then(function () {
                    return datacontext.materia_delete(item.Id).then(function (data) {
                        if (data != "204") return logError($translate.instant('ErroreRimozione'));

                        var index = vm.records.indexOf(item);
                        vm.records.splice(index, 1);
                        vm.countRecords--;
                    });
                });
            }            
        }

        function predefinita(index, value) {
            datacontext.materia_setPredefinita(vm.records[index].MateriaId).then(function (data) {                
                if (data == '200') {
                    cerca();
                    logSuccess($translate.instant('DatoSalvato'));
                }
                else
                    logError($translate.instant('ErroreElaborazione'));
            });
        }

        //****************************************************
        // METODI MATERIA 
        //****************************************************
        function addMateria(item) {
            return datacontext.materia_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) { logError($translate.instant('ErroreCreazione')); return; }

                logSuccess($translate.instant('DatoCreato'));
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function getMateria(id) {
            return datacontext.materia_get(id).then(function (data) {
                return data;
            });
        }

        function updateMateria(item) {
            return datacontext.materia_update(item).then(function (data) {
                if (!data)
                    logSuccess($translate.instant('DatoSalvato'));
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }       

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function openModal(objMateria) {
            if ($rootScope.isAuthorized("DOCENTE")) {       //docenteMateriaAdd
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/materia/modal/docenteMateriaAdd.html?version=43',
                    controller: 'docenteMateriaAdd',
                    resolve: {                        
                    }
                });
                modalInstance.result.then(function (returnItem) {
                    cerca();
                });
            }
            else {                                      //materiaAddEdit
                var newMateria = !objMateria;

                if (newMateria) {
                    objMateria = {};
                }

                var modalMateria = {};
                angular.copy(objMateria, modalMateria);
                modalMateria.materiaId = vm.record.Id;

                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/materia/modal/materiaAddEdit.html?version=43',
                    controller: 'materiaAddEdit',
                    resolve: {
                        materia: function () {
                            return modalMateria;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (newMateria) {
                        addMateria(returnItem);
                    }
                    else {
                        updateMateria(returnItem);
                        angular.copy(returnItem, objMateria);
                    }
                });
            }
        }
    }
})();